export default __webpack_public_path__ + "static/media/3_of_diamonds.b78fe80c.png";